import {createI18n} from '@sollapay/web-core';

import {
  enAuth,
  enAuthorities,
  enCommon,
  enGuest,
  enNav,
  enPayments,
  enSettings,
  enTeam,
  enTrustAccounts
} from '../locales/en';
import {
  heAuth,
  heAuthorities,
  heCommon,
  heGuest,
  heLegal,
  heNav,
  hePayments,
  heSettings,
  heTeam,
  heTrustAccounts
} from '../locales/he';

const i18n = createI18n({
  resources: {
    en: {
      common: enCommon,
      auth: enAuth,
      nav: enNav,
      trustAccounts: enTrustAccounts,
      payments: enPayments,
      settings: enSettings,
      team: enTeam,
      authorities: enAuthorities,
      guest: enGuest
    },
    he: {
      common: heCommon,
      auth: heAuth,
      nav: heNav,
      trustAccounts: heTrustAccounts,
      payments: hePayments,
      settings: heSettings,
      legal: heLegal,
      team: heTeam,
      authorities: heAuthorities,
      guest: heGuest
    }
  },
  fallbackLng: 'he',
  defaultNS: 'common',
  ns: [
    'common',
    'auth',
    'nav',
    'trustAccounts',
    'payments',
    'settings',
    'legal',
    'team',
    'authorities',
    'guest'
  ],
  storageKey: 'i18nextLng'
});

export default i18n;
